var TorsoView = require('backbone-torso/modules/View'),
    listItemTemplate = require('./eregStaffPatientLookupListItemTemplate.hbs');

/**
 * Converts the ssn object into a single string with appropriate replacements for empty pieces.
 * @param [ssn] {Object} the ssn object containing the 3 ssn parts.  If falsey then an empty string is returned.
 *   @param [ssn.first3] {String} the first 3 digits of the ssn.  If falsey and other parts are present then it is replaced with 'xxx'.
 *   @param [ssn.middle2] {String} the middle 2 digits of the ssn.  If falsey and other parts are present then it is replaced with 'xx'.
 *   @param [ssn.last4] {String} the last 4 digits of the ssn.  If falsey and other parts are present then it is replaced with 'xxxx'.
 * @returns {String} [ssn.first3]-[ssn.middle2]-[ssn.last4] where any missing section is replaced by x's.
 *                   ex: 123-45-6789 or xxx-45-6789 or blank if the ssn object is empty, null or undefined.
 */
function parseAndMaskEmptySsnPartsIntoFullSsnString(ssn) {
  var ssnFirst3 = ssn && ssn.first3;
  var ssnMiddle2 = ssn && ssn.middle2;
  var ssnLast4 = ssn && ssn.last4;
  var hasAnySsnField = ssnFirst3 || ssnMiddle2 || ssnLast4;
  var maskedEmptySsnFirst3 = ssnFirst3 || 'xxx';
  var maskedEmptySsnMiddle2 = ssnMiddle2 || 'xx';
  var maskedEmptySsnLast4 = ssnLast4 || 'xxxx';
  return !hasAnySsnField ? '' : maskedEmptySsnFirst3 + '-' + maskedEmptySsnMiddle2 + '-' + maskedEmptySsnLast4;
}

/**
  * View for rendering individual list items for the list view EregStaffPatientLookupResultsView
  *
  * @class EregStaffPatientLookupListItemView
  * @extend Torso.View
  */
module.exports = TorsoView.extend({
  moduleNamespace: 'patientLookupResultsItem',
  template: listItemTemplate,
  tagName: 'li',
  className: 'search-results__item',

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var acceptedDemographics = this.model.get('acceptedDemographics'),
        name = acceptedDemographics.contactInfo.name,
        fullName = name.familyName + ', ' + name.givenName;

    var maskedSsn = acceptedDemographics.ssn;
    maskedSsn.first3 = '';
    maskedSsn.middle2 = '';

    return {
      fullName: fullName,
      fullSSN: parseAndMaskEmptySsnPartsIntoFullSsnString(maskedSsn),
      identifiers: this.model.get('identifiers'),
      dob: acceptedDemographics.dobAsLocalDate,
      vecnaId: acceptedDemographics.vecnaId
    };
  }
});
